import React from 'react'
import Signup from './Signup'
import AuthProvider from './AuthContext';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import Dashbord from './Dashbord';
import Login from './Login'
import Forgotpassword from './Forgotpassword'
import PrivateRoute from "./PrivateRoute"
export default function App() {
    return (
        <>
        <div>
            <Router>
            <AuthProvider>
                <Switch>
                    <PrivateRoute exact path="/" component={Dashbord}></PrivateRoute>
                    <Route path="/signup" component={Signup}></Route>
                    <Route path="/login" component={Login}></Route>
                    <Route path='/resetpassword' component={Forgotpassword}></Route>
                </Switch>
            </AuthProvider>
            </Router>
         
        </div>
        </>
    )
}
